import customFetch from '../../../utils/customFetch';

export const getAllRecords = (keyword = '', curPage = 1, numItemPerPage = 0, sortBy = '', sortDirection = '') => {
  return customFetch('/FundingAgreement/GetAll', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      Keyword: keyword,
      CurPage: curPage,
      NumItemPerPage: numItemPerPage,
      SortBy: sortBy,
      SortDirection: sortDirection,
    }),
  });
};
export const getFundingAgreementInfo = (id = 0) => {
  return customFetch(`/FundingAgreement/GetItemInfo?Id=${id}`, {
    method: 'GET',
  });
};

export const saveData = param => {
  return customFetch('/FundingAgreement/SaveData', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(param),
  });
};

export const deleteRecord = id => {
  return customFetch('/FundingAgreement/Delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
};

export const getFundingRequest = (keyword = '') => {
  return customFetch('/FundingRequest/GetAll', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      Keyword: keyword,
      CurPage: 1,
      NumItemPerPage: 500,
    }),
  });
};

export const getFundedCompanies = keyword => {
  return customFetch('/Company/GetAll', {
    method: 'POST',
    headers: { 'Content-type': 'application/json' },
    body: JSON.stringify({
      ActionRequired: false,
      NumItemPerPage: 500,
      RecruitedOrContractedOnlyge: true,
      SortBy: 'Name',
      SortDirection: 'ASC',
      curPage: 1,
      keyword: keyword,
      ActionRequiredById: '',
      //IsClientFundingProvider: true,
      IsSelectionList: true,
    }),
  });
};

export const getFundingProvider = keyword => {
  return customFetch('/Company/GetAll', {
    method: 'POST',
    headers: { 'Content-type': 'application/json' },
    body: JSON.stringify({
      ActionRequired: false,
      NumItemPerPage: 500,
      RecruitedOrContractedOnlyge: true,
      SortBy: 'Name',
      SortDirection: 'ASC',
      curPage: 1,
      keyword: keyword,
      ActionRequiredById: '',
      IsClientFundingProvider: true,
      IsSelectionList: true,
    }),
  });
};

export const getSigningPerson = (keyword = '', clientId = 0, numberStaff = 500) => {
  return customFetch('/Staff/GetAll?companyId=' + clientId, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      Keyword: keyword,
      IsSelectionList: true,
      Showing: 'active',
      curPage: 1,
      numItemPerPage: numberStaff,
    }),
  });
};
